
import { mapGetters } from "vuex";
import domParser from "@/mixins/domParser";

export default {
	mixins: [domParser],
	props: {
		text: String
	},
	computed: {
		...mapGetters({
			settings: 'settings/settings/settings'
		})
	}
}
